import React from 'react';
import { FaTrash } from 'react-icons/fa';
import loadingSpinner from '../assets/img/Spinner.svg';

export interface ImageItem {
  id: number;
  src: string;
  [key: string]: any;
}

interface ImagesGridProps {
  images: ImageItem[];
  onSelect: (image: ImageItem) => void;
  onDelete?: (id: number) => void;
  isLoading?: boolean;
  itemHeight?: number;
}

const ImagesGrid: React.FC<ImagesGridProps> = ({
  images,
  onSelect,
  onDelete,
  isLoading = false,
  itemHeight = 100,
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <img src={loadingSpinner} alt="Loading..." style={{ width: 48, height: 48 }} />
      </div>
    );
  }

  if (!images || images.length === 0) {
    return (
      <div className="text-center text-gray-400 py-8 text-sm">
        No images uploaded yet.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-2 p-2">
      {images.map((image) => (
        <div
          key={image.id}
          className="relative cursor-grab overflow-hidden rounded border border-gray-200 hover:border-blue-400 transition-colors"
          style={{ height: itemHeight }}
          draggable
          onDragStart={(e) => {
            e.dataTransfer.setData('application/x-image-item', JSON.stringify({ id: image.id, src: image.src }));
            e.dataTransfer.effectAllowed = 'copy';
          }}
          onClick={() => onSelect(image)}
        >
          <img
            src={image.src}
            alt=""
            className="w-full h-full object-cover pointer-events-none"
            style={{ display: 'block' }}
          />
          <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 px-1 py-0.5 flex items-center justify-between">
            <span className="text-white text-xs truncate flex-1">
              {image.src.split('/').pop()}
            </span>
            {onDelete && (
              <button
                className="ml-1 p-0.5 text-white bg-red-600 rounded-full flex-shrink-0"
                onClick={(e) => { e.stopPropagation(); onDelete(image.id); }}
              >
                <FaTrash size={10} />
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImagesGrid;
